import React from 'react'
import { getDate, getTime } from '../../utilities/formatTimestamp'

const CommentCard = ({isDay, siteTheme, props}) => {
  return (
     <div className={`font-thin text-xs shadow-md ${isDay ? "shadow-neutral-400/30" : "shadow-neutral-800/30"} rounded-lg p-3 mb-3`}>
         <p className={`border-b-[0.5px] text-teal ${siteTheme.borderColor} pb-[5px]`}>{props?.name ? `${props?.name} |` : "Anonymous"} {props?.email}</p>
         <p className={`mb-1 text-neutral-500 text-[10px] ${siteTheme.borderColor} pb-1`}>{getTime(props?.timestamp)} | {getDate(props.timestamp, "MMMM YYYY", true)}</p>
         <p className={`leading-5 ml-3 tracking-wider ${siteTheme.textColor}`}>{props?.comment}</p>
      </div>
  )
}

export { CommentCard }
export default CommentCard
